import { getCollection, useCollection } from "hooks/firestore/core/useCollection"
import { WithRef } from "hooks/firestore/FirestoreDocument"
import { getItemsRef, getSubscribersRef } from "hooks/firestore/getRefs"
import { useShopId } from "hooks/localstate/context/useShopId"
import { Subscriber } from "types/firestore/subscriber"

// ts-prune-ignore-next
export function useSubscribers(): WithRef<Subscriber>[] | undefined
export function useSubscribers(shopId: string): WithRef<Subscriber>[] | undefined
export function useSubscribers(shopId?: string) {
  // TypeScript function overloads should prevent conditional calling of the hook
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const realShopId = shopId || useShopId()
  const { documents } = useCollection(getSubscribersRef(realShopId))
  return documents
}

// ts-prune-ignore-next
export async function getItems(offeringId: string) {
  return await getCollection(getItemsRef(offeringId))
}
